import React from 'react'
import { translate, loadNamespaces } from 'react-i18next'
import { getInitialProps, I18n } from './index'

export const withI18next =
  (namespaces = ['global']) =>
  (ComposedComponent) => {
    const Translated = translate(namespaces, {
      i18n: I18n,
      wait: process.browser,
    })(ComposedComponent)

    // react-i18next's <I18n> adopts `initialI18nStore` as the resource store
    // (`services.resourceStore.data = initialI18nStore`). On the server those
    // services are shared by every request, so the page's serialised store
    // became the live store: later loads were written into it (all shop
    // locales, junk cookie "locales") and leaked into other requests' HTML.
    // The server already has every shop locale preloaded and the request's
    // language set, so these props are only passed down in the browser. They
    // are still returned by getInitialProps and serialised for the client.
    const Extended = (props) => {
      if (process.browser) {
        return <Translated {...props} />
      }

      // eslint-disable-next-line react/prop-types, no-unused-vars
      const { initialI18nStore, initialLanguage, ...serverProps } = props

      return <Translated {...serverProps} />
    }

    Extended.displayName = `withI18next(${
      ComposedComponent.displayName || ComposedComponent.name || 'Component'
    })`

    Extended.getInitialProps = async (ctx) => {
      const composedInitialProps = ComposedComponent.getInitialProps
        ? await ComposedComponent.getInitialProps(ctx)
        : {}

      const i18nInitialProps = ctx.req
        ? getInitialProps(ctx.req, namespaces)
        : await loadNamespaces({
            components: [{ props: { namespaces } }],
            i18n: I18n,
          })

      return {
        ...composedInitialProps,
        ...i18nInitialProps,
      }
    }

    return Extended
  }

export default { withI18next }
